import axios from 'axios';
import vue from 'vue';

let service = axios.create({
    baseURL: process.env.BASE_API,
    timeout: 60000,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    },
    withCredentials: true
});

service.interceptors.request.use(config => {
    return config;
}, error => {
    console.log(error);
    Promise.reject(error);
});

service.interceptors.response.use(
    response => response,
    error => {
        console.log('err' + error);// for debug
        vue.$Message.error({
            message: error.message,
            duration: 5 * 1000,
            closable: true
        });
        return Promise.reject(error);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js